/**
 * Generates an error message when a string is empty.
 * 
 * @param guardName - The name of the variable being guarded.
 * @returns A formatted error message.
 */
export const emptyMessage = (guardName: string): string => `${guardName} is empty`;

/**
 * Throws an error if the provided string is empty ('').
 * 
 * @param guardName - The name of the variable being guarded.
 * @param guard - The string to check for emptiness.
 * @throws {Error} Throws an error if `guard` is an empty string.
 */
export const throwEmpty = (guardName: string, guard: string): void => {
  const isEmpty = guard === '';
  if (isEmpty) throw new Error(emptyMessage(guardName));
}